import React, {Component, Fragment} from 'react'
import {
  Button,
  Col,
  DatePicker,
  Form,
  InputNumber,
  Popconfirm,
  Row,
  Select,
  Table,
} from 'antd'
import moment from 'moment'
import {dateVal, getOrdinal} from '../../../../../modules/Utils'
import _ from 'lodash'
import {message} from 'antd/lib/index'
import Templates from '../../../../../api/Templates'

const FormItem = Form.Item
const {Option} = Select
const RangePicker = DatePicker.RangePicker

const EditableCellDays = ({editable, value, onChange, type}) => (
  <div>
    {editable ? (
      <InputNumber
        min={1}
        max={1000}
        style={{width: 100}}
        value={value}
        onChange={value => onChange(value)}
      />
    ) : (
      `${value ? value : ''} ${value && type}`
    )}
  </div>
)

const EditableCellYears = ({editable, value, onChange, type}) => (
  <div>
    {editable ? (
      <InputNumber
        min={1}
        max={1000}
        style={{width: 100}}
        value={value}
        onChange={value => onChange(value)}
      />
    ) : (
      `${value ? getOrdinal(value) : ''} ${value && type}`
    )}
  </div>
)

class KeyTerms extends Component {
  uuid = moment().unix()

  constructor(props) {
    super(props)
    let data = []
    if (!_.isEmpty(_.get(props, 'contract.notice')))
      data = props.contract.notice.map(item => ({...item}))
    data.forEach(i => {
      if (!i.key) i.key = (this.uuid++).toString()
    })
    this.companyKey = (_.get(props, 'contract.company._id') || '').replace(
      'members/',
      '',
    )
    this.cacheData = data.map(item => ({...item}))
    this.state = {
      data,
      fetchingNoticePeriod: false,
    }
    this.templateApi = new Templates()
  }

  async componentDidMount() {
    await this.fetchNoticePeriodTemplate()
  }

  fetchNoticePeriodTemplate = async () => {
    if (_.isEmpty(this.state.data)) {
      try {
        this.setState({fetchingNoticePeriod: true})
        let employeeTemplate = await this.templateApi.read(
          this.companyKey,
          'employee',
        )
        let data = employeeTemplate['notice'] || []
        data.forEach(i => {
          if (!i.key) i.key = (this.uuid++).toString()
        })
        this.setState({data, fetchingNoticePeriod: false})
        this.props.updateContract('notice', data)
      } catch (e) {
        message.error(e.errrorMessage)
        this.setState({fetchingNoticePeriod: false})
      }
    }
  }
  columns = [
    {
      title: 'Working Year',
      dataIndex: 'years',
      render: (text, record) =>
        this.renderColumnsNumbers(text, record, 'years', 'Year'),
    },
    {
      title: 'Notice Period Days',
      dataIndex: 'days',
      render: (text, record) =>
        this.renderColumnsNumbers(text, record, 'days', 'Days'),
    },
    {
      title: 'Operation',
      dataIndex: 'operation',
      render: (text, record) => {
        const {editable} = record
        return (
          <div className="editable-row-operations">
            {editable ? (
              <span>
                <a onClick={() => this.save(record.key)}>Save</a>
                <span className="ant-divider" />
                <Popconfirm
                  title="Sure to cancel?"
                  onConfirm={() => this.cancel(record.key)}>
                  <a>Cancel</a>
                </Popconfirm>
              </span>
            ) : (
              [
                <a onClick={() => this.edit(record.key)}>Edit</a>,
                <span className="ant-divider" />,
                <Popconfirm
                  title="Sure to remove?"
                  onConfirm={() => this.remove(record.key)}>
                  <a>Remove</a>
                </Popconfirm>,
              ]
            )}
          </div>
        )
      },
    },
  ]
  add = () => {
    const newData = [...this.state.data]
    newData.push({key: (this.uuid++).toString(), editable: true})
    this.setState({data: newData})
  }
  cancel = key => {
    const newData = [...this.state.data]
    const target = newData.filter(item => key === item.key)[0]
    if (!_.isEmpty(target)) {
      Object.assign(target, this.cacheData.filter(item => key === item.key)[0])
      delete target.editable
      if (Object.keys(target).length === 1 && Object.keys(target)[0] === 'key')
        this.remove(target.key)
      else this.setState({data: newData})
      this.props.updateContract('notice', newData)
    }
  }
  remove = key => {
    let newData = [...this.state.data]
    newData = newData.filter(item => key !== item.key)
    this.setState({data: newData})
    this.props.updateContract('notice', newData)
  }
  edit = key => {
    const newData = [...this.state.data]
    const target = newData.filter(item => key === item.key)[0]
    if (target) {
      target.editable = true
      this.setState({data: newData})
      this.props.updateContract('notice', newData)
    }
  }
  save = key => {
    const newData = [...this.state.data]
    const target = newData.find(item => key === item.key)
    if (target) {
      const year = newData.find(
        item => target.years === item.years && item.editable !== true,
      )
      if (year) message.error('Condition existed!')
      else if (!(target.years && target.days)) message.error('Invalid Data')
      else {
        delete target.editable
        this.setState({data: newData})
        this.cacheData = newData.map(item => ({...item}))
        this.props.updateContract('notice', newData)
      }
    }
  }
  handleChange = (value, key, column) => {
    const newData = [...this.state.data]
    const target = newData.filter(item => key === item.key)[0]
    if (target) {
      target[column] = value
      this.setState({data: newData})
    }
  }
  renderColumnsNumbers = (text, record, column, type) => {
    return column === 'years' ? (
      <EditableCellYears
        editable={record.editable}
        value={text}
        type={type}
        onChange={value => this.handleChange(value, record.key, column)}
      />
    ) : (
      <EditableCellDays
        editable={record.editable}
        value={text}
        type={type}
        onChange={value => this.handleChange(value, record.key, column)}
      />
    )
  }

  render() {
    const formItemLayout = {
      labelCol: {
        xs: {span: 24},
        sm: {span: 7},
      },
      wrapperCol: {
        xs: {span: 24},
        sm: {span: 16},
      },
    }
    const {getFieldDecorator} = this.props.form
    const {contract, type} = this.props
    if (type === 'view')
      this.columns = this.columns.filter(c => c.dataIndex !== 'operation')

    return (
      <Form layout="horizontal">
        <Row>
          <Col span={12}>
            <FormItem label="Start Date" {...formItemLayout}>
              {getFieldDecorator('date.start', {
                initialValue: dateVal(contract, 'date.start'),
                rules: [
                  {
                    required: true,
                    message: "Start Date can't be empty ",
                  },
                ],
              })(
                <DatePicker style={{width: '100%'}} placeholder="Start Date" />,
              )}
            </FormItem>
          </Col>
          <Col span={12}>
            <FormItem label="End Date" {...formItemLayout}>
              {getFieldDecorator('date.expiry', {
                initialValue: dateVal(contract, 'date.expiry'),
              })(<DatePicker style={{width: '100%'}} placeholder="End Date" />)}
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span={12}>
            <FormItem label="Effective Date" {...formItemLayout}>
              {getFieldDecorator('date.effective', {
                initialValue: dateVal(contract, 'date.effective'),
                rules: [
                  {
                    required: true,
                    message: "Effective  Date can't be empty ",
                  },
                ],
              })(
                <DatePicker
                  style={{width: '100%'}}
                  placeholder="Effective  Date"
                />,
              )}
            </FormItem>
          </Col>
          <Col span={12}>
            <FormItem label="Probation End Date" {...formItemLayout}>
              {getFieldDecorator('date.probation', {
                initialValue: dateVal(contract, 'date.probation'),
                rules: [
                  {
                    required: true,
                    message: "Probation End Date can't be empty ",
                  },
                ],
              })(
                <DatePicker
                  style={{width: '100%'}}
                  placeholder="Probation End Date"
                />,
              )}
            </FormItem>
          </Col>
        </Row>
        <Table
          title={() => (
            <Fragment>
              <span style={{color: '#1890ff'}}>NOTICE PERIOD</span>
              {type !== 'view' && (
                <Button
                  style={{float: 'right'}}
                  size={'small'}
                  onClick={this.add}>
                  Add Condition
                </Button>
              )}
            </Fragment>
          )}
          loading={this.state.fetchingNoticePeriod}
          pagination={false}
          columns={this.columns}
          dataSource={this.state.data.filter(i => i.removed !== true)}
          size="small"
          style={{marginTop: 10}}
        />
      </Form>
    )
  }
}

export default Form.create()(KeyTerms)
